<div class="box">
  <h2 *ngIf="name$; else noUser">Hello {{ (name$ | async) ?? "user" }}</h2>
  <ng-template #noUser>
    <h2>Hello User!</h2>
  </ng-template>
  <h2>Welcome to your personal area.</h2>
  <app-shared-with-me></app-shared-with-me>
</div>
